import { render } from "./RestoreResourceModal.vue?vue&type=template&id=425eb364"
import script from "./RestoreResourceModal.vue?vue&type=script&lang=js"
export * from "./RestoreResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"RestoreResourceModal.vue"]])

export default __exports__